import React from 'react'
// libs
import styled from 'styled-components'
import { reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
import { ReduxEntitySelect, ReduxInput } from 'components/FormElements/ReduxForm'
// constants
import { Forms } from 'constants/forms'
// graphql
import { OBJECT_SECURITIES_QUERY } from 'graphql/objectSecurity/queries'
// views
import { ActionsWrapper } from 'themes/views/modals'
import { InputWrapper, SpaceBetweenWrapper } from 'themes/views/form'
// utils
import { required } from 'utils/validators'
import { objectSecurityProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

// styled
const Form = styled.form`
  flex-grow: 1;
  height: calc(100% - 64px);
`

const PlanTypeCreateForm = ({ handleSubmit, handleCancelClick, valid }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <SpaceBetweenWrapper>
        <Scrollbar>
          <InputWrapper>
            <ReduxInput outlined label={'Code'} name={'code'} validate={[required]} />
          </InputWrapper>
          <InputWrapper>
            <ReduxInput outlined label={'Description'} name={'description'} validate={[required]} />
          </InputWrapper>

          <InputWrapper>
            <ReduxEntitySelect
              label={'Plan Owner Security Assignment'}
              name={'planOwnerObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'plans' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              label={'Default Plan Member Security Assignment'}
              name={'planMemberObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'plans' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              label={'Objective Owner Security Assignment'}
              name={'objectiveOwnerObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'objectives' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              label={'Default Objective Member Security Assignment'}
              name={'objectiveMemberObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'objectives' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              label={'Indicator Owner Security Assignment'}
              name={'kpiOwnerObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'kpis' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              label={'Default Indicator Member Security Assignment'}
              name={'kpiMemberObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'kpis' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              label={'Action Owner Security Assignment'}
              name={'actionOwnerObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'actions' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
          <InputWrapper>
            <ReduxEntitySelect
              menuPlacement='top'
              label={'Default Action Member Security Assignment'}
              name={'actionMemberObjectSecurity'}
              query={OBJECT_SECURITIES_QUERY}
              validate={[required]}
              variables={{ filter: { objectEntityApiName: 'actions' } }}
              {...objectSecurityProps}
            />
          </InputWrapper>
        </Scrollbar>
        <ActionsWrapper>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE} type={'submit'} disabled={!valid}>
            Create
          </Button>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={handleCancelClick}>
            Cancel
          </Button>
        </ActionsWrapper>
      </SpaceBetweenWrapper>
    </Form>
  )
}

export default reduxForm({ form: Forms.PLAN_TYPE_CREATE_FORM })(PlanTypeCreateForm)
